/**
 * PPP
 * @flow
 */
'use strict';
import React, {Component} from 'react';
import {
  Dimensions,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import AMWebView from '../components/AMWebView';
import ScreenComponent from '../components/ScreenComponent';

import PlatformController from '../classes/PlatformController';
import {colors} from '../classes/Colors';
import BooksController from '../classes/BooksController';

import {getBookSectionSlideCSS} from '../css/BookSectionSlide';

export default class BookSectionSlide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      html: '',
    };
  }

  async componentDidMount() {
    const contentHTML = this.props.sectionHTML;
    const updatedHtml = await BooksController.replaceContentsImageSrcs(
      contentHTML,
      this.props.book.ID,
    );

    if (Platform.OS === 'web') {
      const chapterButtons = document.querySelectorAll('button');
      const chapterAnchors = document.querySelectorAll('a');

      // Iterate over each anchor and modify styles and behavior
      chapterAnchors.forEach(chapterAnchor => {
        if (chapterAnchor.style) {
          chapterAnchor.style.all = 'unset';
          chapterAnchor.style.color = 'black';
          chapterAnchor.style.cursor = 'default'; // or 'auto'
        }

        // Add click event listener to prevent default behavior
        chapterAnchor.addEventListener('click', event => {
          event.preventDefault(); // Prevent the default navigation
          console.log('link clicked');
          // Add any additional custom behavior here
        });
      });

      // Iterate over each anchor and modify styles and behavior
      chapterButtons.forEach(chapterLink => {
        if (chapterLink?.style) {
          // Apply desired styles
          chapterLink.style.textDecoration = 'underline';
          chapterLink.style.color = 'rgb(85, 26, 139)';
          chapterLink.style.backgroundColor = 'transparent';
          chapterLink.style.border = 'none';
          chapterLink.style.cursor = 'pointer';
          chapterLink.style.fontSize = '16px';
          chapterLink.style.padding = '0px';
        }

        const href = chapterLink.getAttribute('href');
        chapterLink.addEventListener('click', () => {
          if (href.includes('caseStudy')) {
            let parts = href.split('-');
            if (parts.length === 2) {
              let caseStudyName = parts[1];

              this.props.goToCaseStudy(caseStudyName);
            }
          }

          if (href.includes('CH')) {
            const chapter = href.replace('CH', '');
            let parts = chapter.split('-');
            if (parts.length === 2) {
              let chapterIndex = parseInt(parts[0]);
              let sectionIndex = parseInt(parts[1]);

              this.props.goToSection(chapterIndex, sectionIndex);
            }
          }
        });
      });
    }

    this.setState({html: updatedHtml});
  }

  handleWebViewRequest = (event, props) => {
    const shouldIntercept =
      event.navigationType === 'click' || Platform.OS === 'android';

    if (!shouldIntercept) return true;

    const url = event.url;
    let lastPathComponent = url.substring(url.lastIndexOf('/') + 1);

    if (url.includes('http') || url.includes('www') || url.includes('mailto')) {
      PlatformController.openURL(url);
      return false;
    }

    if (url.includes('glid://')) {
      const glid = url.replace('glid://', '');
      // props.goToReference(glid);
      return false;
    }

    lastPathComponent = lastPathComponent.replace(/%20/g, '');

    if (lastPathComponent.startsWith('CH')) {
      const cleanPath = lastPathComponent.replace(/CH/g, '');
      const parts = cleanPath.split('-');
      if (parts.length === 2) {
        const chapterIndex = parseInt(parts[0], 10);
        const sectionIndex = parseInt(parts[1], 10);
        props.goToSection?.(chapterIndex, sectionIndex);
      }
      return false;
    }

    if (lastPathComponent.startsWith('caseStudy')) {
      const parts = lastPathComponent.split('-');
      if (parts.length === 2) {
        const caseStudyName = parts[1];
        props.goToCaseStudy?.(caseStudyName);
      }
      return false;
    }

    if (lastPathComponent.startsWith('#')) {
      return true;
    }

    return false;
  };

  onMessage(m) {
    var message = m.nativeEvent.data;
    if (message.includes('bookImageTapped')) {
      var imageString = message.replace('bookImageTapped-', '');
      this.props.openImageModal(imageString);
    }
    if (message.includes('readButtonTapped')) {
      let messageComponenets = message.split('-');
      if (messageComponenets.length > 1) {
        let type = messageComponenets[1];
        this.props.readButtonTapped(type);

        if (this.webView) {
          setTimeout(() => {
            this.webView.injectJavaScript(`
              window.scroll({
                top: 1000000, 
                left: 0, 
                behavior: 'instant'
              })
            `);
          }, 200);
        }
      }
    }
    if (message.includes('paraFolioButtonTapped')) {
      let messageComponenets = message.split('-');
      if (messageComponenets.length > 1) {
        let type = messageComponenets[1];
        this.props.paraFolioButtonTapped(type);
      }
    }
    if (message.includes('quizButtonTapped')) {
      let messageComponents = message.split('-');
      if (messageComponents.length > 1) {
        const {quizset, onPressHandler} = this.props.quizDetails;
        onPressHandler(quizset);
      }
    }
  }

  render() {
    const shouldRenderSlide =
      this.props.index > this.props.activeIndex - 2 &&
      this.props.index < this.props.activeIndex + 2;

    if (shouldRenderSlide) {
      // slide is near active index so render it
      const script = `
        <script>
  
          document.addEventListener('DOMContentLoaded', function(){ 
            // your code goes here
            
            var highlightedElements = document.getElementsByClassName('searchHighlightCurrent');
            if (highlightedElements.length > 0) {
              var highlightedElement = highlightedElements[0];
              highlightedElement.scrollIntoView({block: "center"});
            }
  
            let imageElements = document.getElementsByClassName("bookImage");
            console.log('image elements: ' + imageElements.length);
            for(let i = 0; i < imageElements.length; i++) {
              let imageElement = imageElements[i];
              imageElement.onclick = function () {
                if (window.ReactNativeWebView != null && window.ReactNativeWebView.postMessage != null) {
                  console.log('imageElement.src' + imageElement.src);
                  window.ReactNativeWebView.postMessage("bookImageTapped-" + imageElement.src);
                }  
              }
            }
  
            let readButtonElements = document.getElementsByClassName("bookReadButton");
            for(let i = 0; i < readButtonElements.length; i++) {
              let readButtonElement = readButtonElements[i];
              readButtonElement.onclick = function () {
                if (window.ReactNativeWebView != null && window.ReactNativeWebView.postMessage != null) {
                  window.ReactNativeWebView.postMessage("readButtonTapped-" + readButtonElement.id);
                }  
              }
            }

            let quizButtonElements = document.getElementsByClassName("bookQuizButton");
            for(let i = 0; i < quizButtonElements.length; i++) {
              let quizButtonElement = quizButtonElements[i];
              quizButtonElement.onclick = function () {
                if (window.ReactNativeWebView != null && window.ReactNativeWebView.postMessage != null) {
                  window.ReactNativeWebView.postMessage("quizButtonTapped-" + quizButtonElement.id);
                }  
              }
            }
  
            let paraFolioButtonElements = document.getElementsByClassName("bookParaFolioButton");
            for(let i = 0; i < paraFolioButtonElements.length; i++) {
              let paraFolioButtonElement = paraFolioButtonElements[i];
              paraFolioButtonElement.onclick = function () {
                if (window.ReactNativeWebView != null && window.ReactNativeWebView.postMessage != null) {
                  window.ReactNativeWebView.postMessage("paraFolioButtonTapped-" + paraFolioButtonElement.id);
                }  
              }
            }
  
          }, false);
        </script>
      `;

      const styleCSS = `
        <style>
          ${getBookSectionSlideCSS(this.props.fontSize)}
          ${this.props.book.cssSource}
        </style>
      `;

      let contentHTML = this.state.html;

      contentHTML = contentHTML.replace(/\r/g, '');
      contentHTML = contentHTML.replace(/\n/g, '');

      // replace page links
      contentHTML =
        Platform.OS === 'web'
          ? contentHTML.replace(/pp-link/g, 'button')
          : contentHTML.replace(/pp-link/g, 'a');

      contentHTML = this.props.addHighlights(contentHTML, this.props.isActive);

      const headerHTML =
        '<h1 class="chapterTitle">' + this.props.chapterName + '</h1><hr>';

      var readButtonHtml = ``;
      let quizButtonHtml = ``;

      if (Platform.OS !== 'web') {
        if (this.props?.quizDetails?.quizset) {
          quizButtonHtml = `
            <div class='bookButtonsContainer'>
              <div class='bookQuizLabel'>${this.props?.quizDetails?.quizset.title}</div>
              <div id='chapter' class='bookQuizButton'>Take quiz</div>
            </div>`;
        }
        if (this.props.isSectionRead(this.props.name)) {
          readButtonHtml = `
            <div class='bookButtonsContainer'>
              <div class='bookReadTitleLabel'>You've read this subchapter</div>
              <div id='section' class='bookReadButton bookReadButtonFinished'>Read</div>
            </div>`;
        } else {
          readButtonHtml = `
            <div class='bookButtonsContainer'>
              <div class='bookReadTitleLabel'>Finished reading this subchapter?</div>
              <div id='section' class='bookReadButton'>Mark as read</div>
            </div>`;
        }

        if (this.props.isLastSectionOfChapter) {
          if (this.props.isChapterRead(this.props.name)) {
            readButtonHtml += `
              <div class='bookButtonsContainer'>
                <div class='bookReadTitleLabel'>You've read this chapter</div>
                <div id='chapter' class='bookReadButton bookReadButtonFinished'>Read</div>
                <div id='chapter' class='bookParafolioButton'>Add to ParaFolio</div>
              </div>`;
          } else {
            readButtonHtml += `
              <div class='bookButtonsContainer'>
                <div class='bookReadTitleLabel'>Finished reading this chapter?</div>
                <div id='chapter' class='bookReadButton'>Mark as read</div>
              </div>`;
          }
        }
      }

      const rawHtml =
        "<html><head><meta name='viewport' content='initial-scale=1.0, maximum-scale=1.0'>" +
        styleCSS +
        "</head><body><div class='standby-content-container'>" +
        headerHTML +
        contentHTML +
        quizButtonHtml +
        readButtonHtml +
        "<span class='hiddenText'>" +
        1 +
        '</span></div>' +
        script +
        '</body></html>';

      const scalesPageToFit = Platform.OS === 'android';

      var webContentLayout = (
        <View style={{flex: 1}}>
          <AMWebView
            ref={ref => (this.webView = ref)}
            source={{html: rawHtml, baseUrl: 'file://'}}
            scalesPageToFit={scalesPageToFit}
            useWebKit={true}
            javaScriptEnabled={true}
            // onNavigationStateChange={this.onNavigationChange.bind(this)}
            onMessage={m => this.onMessage(m)}
            setSupportMultipleWindows={false}
            originWhitelist={['*']}
            allowFileAccess={true}
            allowFileAccessFromFileURLs={true}
            allowUniversalAccessFromFileURLs={true}
            onShouldStartLoadWithRequest={event =>
              this.handleWebViewRequest(event, this.props)
            }
            onError={syntheticEvent => {
              const {nativeEvent} = syntheticEvent;
              console.warn('WebView error: ', nativeEvent);
            }}
          />
        </View>
      );

      if (Platform.OS === 'web') {
        var readButtonLayout = [];
        const quizButtonLayout = [];

        if (this.props?.quizDetails?.quizset) {
          const {quizset, onPressHandler} = this.props.quizDetails;
          quizButtonLayout.push(
            <View>
              <Text style={styles.bookReadTitleLabel}>{quizset.title}</Text>
              <TouchableOpacity onPress={onPressHandler}>
                <Text style={[styles.quizButton]}>Take quiz</Text>
              </TouchableOpacity>
            </View>,
          );
        }

        if (this.props.isSectionRead(this.props.name)) {
          readButtonLayout.push(
            <View>
              <Text style={styles.bookReadTitleLabel}>
                You've read this subchapter
              </Text>
              <TouchableOpacity
                onPress={this.onMessage.bind(this, {
                  nativeEvent: {data: 'readButtonTapped-section'},
                })}>
                <Text style={[styles.bookReadButton]}>Mark as unread</Text>
              </TouchableOpacity>
            </View>,
          );
        } else {
          readButtonLayout.push(
            <View>
              <Text style={styles.bookReadTitleLabel}>
                Finished reading this subchapter?
              </Text>
              <TouchableOpacity
                onPress={this.onMessage.bind(this, {
                  nativeEvent: {data: 'readButtonTapped-section'},
                })}>
                <Text style={[styles.bookReadButton]}>Mark as read</Text>
              </TouchableOpacity>
            </View>,
          );
        }

        if (this.props.isLastSectionOfChapter) {
          if (this.props.isChapterRead(this.props.name)) {
            readButtonLayout.push(
              <View>
                <Text style={styles.bookReadTitleLabel}>
                  You've read this chapter
                </Text>
                <TouchableOpacity
                  onPress={this.onMessage.bind(this, {
                    nativeEvent: {data: 'readButtonTapped-chapter'},
                  })}>
                  <Text style={[styles.bookReadButton]}>Mark as unread</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={this.onMessage.bind(this, {
                    nativeEvent: {data: 'paraFolioButtonTapped-chapter'},
                  })}>
                  <Text style={[styles.bookParafolioButton]}>
                    Add to ParaFolio
                  </Text>
                </TouchableOpacity>
              </View>,
            );
          } else {
            readButtonLayout.push(
              <View>
                <Text style={styles.bookReadTitleLabel}>
                  Finished reading this chapter?
                </Text>
                <TouchableOpacity
                  onPress={this.onMessage.bind(this, {
                    nativeEvent: {data: 'readButtonTapped-chapter'},
                  })}>
                  <Text style={[styles.bookReadButton]}>Mark as read</Text>
                </TouchableOpacity>
              </View>,
            );
          }
        }

        webContentLayout = (
          <div className="content">
            <div dangerouslySetInnerHTML={{__html: rawHtml}} />
            {quizButtonLayout}
            {readButtonLayout}
          </div>
        );
      }

      return (
        <ScreenComponent key={this.props.index} style={{flex: 1}}>
          {webContentLayout}
        </ScreenComponent>
      );
    } else {
      // slide is not near active index so render dummy slide
      return <View />;
    }
  }
}

const {width} = Dimensions.get('window');
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  child: {width: width},
  bookReadTitleLabel: {
    fontWeight: '700',
    textAlign: 'center',
    fontSize: 18,
    marginBottom: 10,
  },
  bookReadButton: {
    alignSelf: 'center',
    fontWeight: '700',
    fontSize: 18,
    paddingTop: 13,
    paddingBottom: 13,
    textAlign: 'center',
    width: 342,
    marginBottom: 20,
    borderRadius: 8,
    color: colors.ButtonBlue,
    borderColor: colors.ButtonBlue,
    borderWidth: 1,
    backgroundColor: colors.white,
  },
  quizButton: {
    alignSelf: 'center',
    fontWeight: '700',
    fontSize: 18,
    paddingTop: 13,
    paddingBottom: 13,
    textAlign: 'center',
    width: 342,
    marginBottom: 20,
    borderRadius: 8,
    color: colors.white,
    borderColor: colors.ButtonBlue,
    borderWidth: 1,
    backgroundColor: colors.ButtonBlue,
  },
  bookParafolioButton: {
    alignSelf: 'center',
    fontWeight: '700',
    fontSize: 18,
    paddingTop: 13,
    paddingBottom: 13,
    textAlign: 'center',
    width: 342,
    marginBottom: 20,
    borderRadius: 8,
    color: colors.ButtonBlue,
    borderColor: colors.ButtonBlue,
    borderWidth: 1,
    backgroundColor: colors.white,
  },
});
